
import {
  categoryUrl,
  chargersUrl,
  teamsUrl,
  userTypeUrl,
  userUrl,
  transactionsUrl,
  getTeamUrl,
  transactionIdUrl,
  meterValueUrl,
  tagsUrl,
  tagsForRemoteOpUrl,
  availableTagsUrl,
  tagIdUrl,
  chargerIdUrl,
  priceGroupsUrl,
  priceGroupIdUrl,
  teamUrlId,
  teamUsersUrl,
  teamChargersWithoutLicenseUrl,
  teamChargerLicenseConfigUrl,
  teamAvailableChargerLicensesUrl,
  chargerLicenseUrl,
  teamChargerLicenseReportUrl,
  getUserDetailUrl,
  usersUrl,
  getUserProfile,
  getProfileChargerLicenseUrl,
  rolesUrl,
  chargerTransactions,
  tagTransactions,
  companyUrl,
  companyFeatureEntitlementsUrl,
  getRoleUrlId,
  featureUrl,
  getCompanyUrlId,
  viewLogsUrl,
  getConnectorsUrl,
  getTagsByChargerIdUrl,
  getCustomerById,
  customerTagsById,
  tagChargerUrl,
  chargerActiveTransactions,
  tagUserUrl,
  serviceRequestUrl,
  serviceRequestForParentUrl,
  getServiceRequestDetailsUrl,
  refundUrl,
  getSettlementPercentageUrl,
  getPaymentDetailsForPriceGroupUrl,
  getPaymentDetailsOfCompany,
  cmCustomerUrl,
  newGetTeamUrl,
  bulkCalPayoutsUrl,
  getTransactionUrl,
  getCurrenciesUrl,
  bulkInvoiceExportList,
  getSmsGatewayUrl,
  getTeamV3Url,
  cmsUsersUrl,
  resetPasswordByAdminUrl,
  cmUserWalletHistoryUrl,
  cmUserTransactionHistoryUrl,
  customerListByTeamIdUrl,
  getChargerInstructionBoardUrl,
  teamPayoutInvoices,
  getPayoutInvoicesPdfUrl,
  getDropDownValues,
  reportGst,
  productCatalogUrl,
  getProductCatalogUrlId,
  companyProductCatalogUrl,
  getCompanyProductCatalogUrlId,
  getCompanyProductCatalogUrl,
  getProductCategoryUrlId,
  productCategoryUrl,
  filterCategoryUrl,
  getFilterCategoryUrlId,
  getFilterItemUrlId,
  getFilterItemsByCategoryUrl,
  getERPDropDownValues,
  availablePaymentGatewayListByCompanyUrl,
  thirdPartySmsConfig,
  smsTemplatesUrl,
  getChargerListUrl,
  partnersUrl,
  onboardUrl,
  handshake,
  handshakeAsyncUrl,
  handshakeRetryUrl,
  handshakeCancelUrl,
  handshakeStatusAsyncUrl,
  ocpiTokensUrl,
  ocpiTokenUrl,
  partnerUrl,
  partnerByPartyIdUrl,
  partnerCommandsUrl,
  partnerSendCommandUrl,
  partnerCommandStatusUrl,
  partnerGetAllTokensUrl,
  commandBuilderDataUrl,
  commandsHistoryUrl,
  activeCommandsUrl,
  ongoingSessionsUrl,
  completedSessionsUrl,
  partnerGetAllTariffsUrl,
  emspMarkupUpsertUrl,
  getPayoutRunHistoryUrl,
  getPayoutRunDetailUrl,
  payoutReportList,
  analyticsUrl,
  analyticsTypesUrl,
  analyticsMetadataUrl,
  analyticsMetricsUrl,
  analyticsReportUrl,
  getAllLocationsUrl,
  dashboardDataUrl,
  promoCodesUrl,
  promoCodeByIdUrl,
  checkPromoCodeUrl,
  updatePromoCodeStatusUrl,
  mobileCustomersListByTeamIdUrl,
  mobileCpoOnboardingListUrl,
  mobileCpoOnboardingDetailUrl,
  mobileCpoOnboardingTimelineUrl,
  mobileCpoOnboardingStatsUrl,
  mobileCpoOnboardingHandoffPreviewUrl,
  sendPromoCodeMobileCustomerUrl,
  cmUserDetailsUrl,
  getPromoCodesUrl,
  getLicensesDetailsUrl,
  refundUrlPaginated,
  initiateChargerLicenseSaleUrl,
  teamPayoutScheduleUrl,
  fleetOperatorsUrl,
  fleetOperatorIdUrl,
  fleetDriversUrl,
  fleetVehiclesUrl,
  fleetAssignmentsUrl,
  fleetChargerAccessUrl,
  fleetTariffsUrl,
  fleetTariffIdUrl,
  fleetWalletUrl,
  fleetWalletLedgerUrl,
  fleetRfidMappingsUrl,
  fleetOperatorUsersUrl,
  fleetSessionsUrl,
  fleetReportSummaryUrl,
  mobileCpoChargerInventoryUrl,
} from "./endPoints";

// Fetch size for client-paginated fleet tables (backend lists default to 10 rows).
const FLEET_LIST_PAGE_SIZE = 500;
const FLEET_LIST_QUERY = `?page=0&pageSize=${FLEET_LIST_PAGE_SIZE}`;

export const queryKeys = {
  //   authenticate: (chargerId) => {
  //     return ["charger", { method: "GET", url: chargerUrl(chargerId) }];
  //   },
  user: () => ["user", { url: userUrl }],
  users: (teamId) => ["users", { url: usersUrl(teamId) }],
  roles: (teamId) => ["roles", { url: rolesUrl(teamId) }],
  role: (teamId, roleId) => ["getRole", { url: getRoleUrlId(teamId, roleId) }],
  usersByTeam: (_, id) => [
    "usersByTeam",
    { url: getTeamUrl(id, teamUsersUrl) },
  ],
  chargersWithoutLicense: (teamId) => [
    "chargersWithoutLicense",
    { url: teamChargersWithoutLicenseUrl(teamId) },
  ],
  chargerLicenseConfig: (teamId) => [
    "chargerLicenseConfig",
    { url: teamChargerLicenseConfigUrl(teamId) },
  ],
  payoutSchedule: (teamId) => [
    "payoutSchedule",
    { url: teamPayoutScheduleUrl(teamId) },
  ],
  availableChargerLicenses: (teamId) => [
    "availableChargerLicenses",
    { url: teamAvailableChargerLicensesUrl(teamId) },
  ],
  addChargerLicense: (teamId) => [
    "addChargerLicense",
    { url: chargerLicenseUrl(teamId) },
  ],
  settlementPercentage: [
    "getSettlementPercentage",
    { url: getSettlementPercentageUrl },
  ],
  paymentDetailsForPriceGroup: (teamId) => [
    "getPaymentDetailsForPriceGroup",
    { url: getPaymentDetailsForPriceGroupUrl(teamId) },
  ],
  paymentDetailsOfCompany: (companyId) => [
    "getPaymentDetailsOfCompany",
    { url: getPaymentDetailsOfCompany(companyId) },
  ],
  setupCatgegory: (body) => ["setupCatgegory", { url: categoryUrl, body }],
  setupUserType: (body) => ["setupUserType", { url: userTypeUrl, body }],
  chargers: (teamId, args) => [
    "getChargers",
    { url: getTeamUrl(teamId, `${chargersUrl}${args ? '?c=' + args.c : ''}`) },
  ],
  chargerList: (teamId, params) => [
    "getPaginatedChargers",
    {
      url: getChargerListUrl(teamId, params)
    },
  ],
  charger: (teamId, chargerId) => [
    "getCharger",
    { url: getTeamUrl(teamId, chargerIdUrl(chargerId)) },
  ],
  generateQR: (teamId, chargerId) => [
    "generateQR",
    { url: getTeamUrl(teamId, `/charger/${chargerId}/generateQr`) },
  ],
  transactions: (teamId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, transactionsUrl) },
  ],
  transactionStatus: (teamId, transactionId) => [
    "transactionStatus",
    { url: getTeamUrl(teamId, `/${transactionIdUrl(transactionId)}/status`) },
  ],
  chargerTransactions: (teamId, chargerId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, chargerTransactions(chargerId)) },
  ],
  chargerActiveTransactions: (teamId, chargerId) => [
    "getActiveTransactions",
    { url: getTeamUrl(teamId, chargerActiveTransactions(chargerId)) },
  ],
  tagTransactions: (teamId, tagId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, tagTransactions(tagId)) },
  ],
  transaction: (teamId, transactionId) => [
    "getTransaction",
    { url: getTeamUrl(teamId, transactionIdUrl(transactionId)) },
  ],
  transactionMeterValue: (teamId, transactionId, connectorId) => [
    "getMeterValue",
    {
      url: getTeamUrl(
        teamId,
        meterValueUrl(transactionIdUrl(transactionId), connectorId)
      ),
    },
  ],
  serviceRequest: (teamId) => [
    "getServiceRequests",
    { url: serviceRequestUrl(teamId) },
  ],
  serviceRequestForParent: (id) => [
    "getServiceRequestsForParent",
    { url: serviceRequestForParentUrl(id) },
  ],
  serviceRequestDetails: (teamId, id) => [
    "getServiceRequestDetails",
    { url: getServiceRequestDetailsUrl(teamId, id) },
  ],
  chargingProfileList: (teamId, charging_profile_pk) => [
    "getChargingProfileList",
    { url: newGetTeamUrl(teamId, charging_profile_pk) },
  ],
  chargingProfileDetails: (teamId, chargingProfileId) => [
    "getChargingProfileDetails",
    { url: newGetTeamUrl(teamId, chargingProfileId) },
  ],
  refund: (teamId, tId = 0) => [
    "refund",
    { url: `${refundUrl(teamId)}${tId ? "/" + tId : ""}` },
  ],

  // this is new key for paginated refund list, we can remove above refund key once all the components are migrated to use this new key
  refundPaginated: (teamId, page = 0, pageSize = 10, search = "") => [
    "refund",
    {
      url: refundUrlPaginated(teamId, page, pageSize, search),
      teamId,
      page,
      pageSize,
      search
    }
  ],
  tags: (teamId) => ["getTags", { url: getTeamUrl(teamId, tagsUrl) }],
  tagsForRemoteOp: (teamId, chargerPk, mail) => [
    "getTagsForRemoteOp",
    {
      url: getTeamUrl(teamId, tagsForRemoteOpUrl, chargerPk),
      method: "POST",
      body: { email: mail },
    },
  ],
  availableTags: (teamId, customerId) => [
    "availableTags",
    { url: getTeamUrl(teamId, availableTagsUrl, customerId) },
  ],
  tag: (teamId, tagId) => [
    "getTag",
    { url: getTeamUrl(teamId, tagIdUrl(tagId)) },
  ],
  tagsCharger: (teamId, tagId, chargerId = null) => [
    "getTagCharger",
    { url: getTeamUrl(teamId, tagChargerUrl(tagId, chargerId)) },
  ],
  tagsUser: (teamId, tagId) => [
    "getTagUser",
    { url: tagUserUrl(teamId, tagId) },
  ],
  priceGroups: (teamId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupsUrl) },
  ],
  priceGroup: (teamId, priceGroupId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupIdUrl(priceGroupId)) },
  ],
  teams: (parentTeamId) => ["getTeams", { url: teamsUrl(parentTeamId) }],

  team: (id) => ["getTeam", { url: teamUrlId(id) }],
  getComapnyProductCatalog: (teamId) => ["getCompanyProductCatalogUrl", { url: getCompanyProductCatalogUrl(teamId) }],
  userDetail: (teamId, id) => ["getUser", { url: getUserDetailUrl(teamId, id) }],
  profile: () => ["getProfile", { url: getUserProfile() }],
  companyList: () => ["companyList", { url: companyUrl }],
  productCatalog: () => ["productCatalog", { url: productCatalogUrl }],
  productCategory: () => ["productCategory", { url: productCategoryUrl }],
  filterCategory: (teamId) => ["filterCategory", { url: filterCategoryUrl(teamId) }],
  getFilterCategory: (teamId, categoryId) => ["getFilterCategory", { url: getFilterCategoryUrlId(teamId, categoryId) }],
  filterItems: (teamId, categoryId) => ["filterItems", { url: getFilterItemsByCategoryUrl(teamId, categoryId) }],
  getFilterItem: (teamId, itemId) => ["getFilterItem", { url: getFilterItemUrlId(teamId, itemId) }],
  companyproductCatalogUrl: () => ["companyProductCatalog", { url: companyProductCatalogUrl }],
  companyProductCatalog: (teamId, id) => [
    "getCompanyProductCatalog",
    { url: getCompanyProductCatalogUrlId(id) },
  ],
  getProductDetails: (teamId, productId) => ["getProductDetails", { url: getProductCatalogUrlId(productId) }],
  getProductCategory: (teamId, categoryId) => ["getProductCategory", { url: getProductCategoryUrlId(categoryId) }],
  company: (teamId, id) => ["getCompany", { url: getCompanyUrlId(id) }],
  companyFeatureEntitlements: (teamId, companyId) => [
    "getCompanyFeatureEntitlements",
    { url: companyFeatureEntitlementsUrl(companyId) },
  ],
  features: () => ["getFeatures", { url: featureUrl }],
  viewLogs: (teamId, chargerId) => [
    "viewLogs",
    { url: getTeamUrl(teamId, viewLogsUrl(chargerId)) },
  ],
  getConnectorsUrl: (teamId, chargerId) => [
    "getConnectorsUrl",
    { url: getTeamUrl(teamId, getConnectorsUrl(chargerId)) },
  ],
  getTagsByChargerId: (teamId, chargerId) => [
    "getTagsByChargerId",
    { url: getTeamUrl(teamId, getTagsByChargerIdUrl(chargerId)) },
  ],
  customers: (t, [s]) => [
    "customerList",
    { url: customerListByTeamIdUrl(t) + "?cmType=" + s.cmType },
  ],
  mobileCustomers: (t, page = 0, pageSize = 10, search = "") => [
    "mobileCustomerList",
    { url: mobileCustomersListByTeamIdUrl(t, page, pageSize, search) },
  ],
  mobileCpoOnboardingList: (companyId, page = 0, pageSize = 10, search = "", status = "") => [
    "mobileCpoOnboardingList",
    { url: mobileCpoOnboardingListUrl(companyId, page, pageSize, search, status) },
  ],
  mobileCpoOnboardingDetail: (companyId, requestPk) => [
    "mobileCpoOnboardingDetail",
    { url: mobileCpoOnboardingDetailUrl(companyId, requestPk) },
  ],
  mobileCpoOnboardingTimeline: (companyId, requestPk) => [
    "mobileCpoOnboardingTimeline",
    { url: mobileCpoOnboardingTimelineUrl(companyId, requestPk) },
  ],
  mobileCpoOnboardingHandoffPreview: (companyId, requestPk) => [
    "mobileCpoOnboardingHandoffPreview",
    { url: mobileCpoOnboardingHandoffPreviewUrl(companyId, requestPk) },
  ],
  mobileCpoOnboardingStats: (companyId, start, end, baseStart, baseEnd) => [
    "mobileCpoOnboardingStats",
    { url: mobileCpoOnboardingStatsUrl(companyId, start, end, baseStart, baseEnd) },
  ],
  mobileCpoChargerInventory: (companyId, page = 0, pageSize = 10, search = "", status = "") => [
    "mobileCpoChargerInventory",
    { url: mobileCpoChargerInventoryUrl(companyId, page, pageSize, search, status) },
  ],
  sendPromoCodeMobileCustomers: (t) => [
    "sendPromoCodeMobileCustomers",
    { url: sendPromoCodeMobileCustomerUrl(t) },
  ],
  customer: (t, id) => ["customer", { url: getCustomerById(t, id) }],
  customerTags: (teamId, customerId) => [
    "customerTags",
    { url: customerTagsById(teamId, customerId) },
  ],
  cmCustomers: () => ["cmCustomerList", { url: cmCustomerUrl }],
  cmsUsers: () => ["cmsUsersList", { url: cmsUsersUrl }],
  cmUserDetails: (teamId, id) => ["cmUserDetails", { url: cmUserDetailsUrl(teamId, id) }],
  cmWalletHistory: (teamId, id) => [
    "cmWalletHistory",
    { url: cmUserWalletHistoryUrl(teamId, id) },
  ],
  cmCustomerTransactionHistory: (teamId, userId) => [
    "cmCustomerTransactionHistory",
    { url: cmUserTransactionHistoryUrl(teamId, userId) },
  ],
  getPromoCodes: (teamId, id) => [
    "getPromoCodes",
    { url: getPromoCodesUrl(teamId, id) },
  ],
  payoutBulkCal: (teamId) => [
    "getBulkCalPayouts",
    { url: getTeamUrl(teamId, bulkCalPayoutsUrl) },
  ],
  transactionList: (
    teamId,
    page,
    pageSize,
    filterteam,
    filterGPTeam,
    companyType,
    search = ""
  ) => [
      "getTransactions",
      {
        url: getTransactionUrl(
          teamId,
          transactionsUrl,
          page,
          pageSize,
          filterteam,
          filterGPTeam,
          companyType,
          search
        ),
      },
    ],
  // Download Center list. Polled while any row is PENDING/PROCESSING.
  bulkInvoiceExports: (teamId) => [
    "bulkInvoiceExports",
    { url: bulkInvoiceExportList(teamId) },
  ],
  getCurrencies: () => ["getCurrencies", { url: getCurrenciesUrl() }],
  getSmsGateway: () => ["getSmsGateway", { url: getSmsGatewayUrl() }],
  generatePaymentLink: (teamId, chargerId) => [
    "generatePaymentLink",
    {
      url: getTeamV3Url(teamId, `/charger/${chargerId}/generate_payment_link`),
    },
  ],
  cmUserPassword: () => ["cmUserPassword", { url: resetPasswordByAdminUrl }],
  chargerInstructionBoard: (teamId, chargerId) => [
    "getChargerInstructionBoard",
    { url: getChargerInstructionBoardUrl(teamId, chargerId) },
  ],
  payoutInvoices: (id, body) => [
    "getPayoutInvoices",
    { url: teamPayoutInvoices(id), body },
  ],
  payoutInvoicesPdf: (id, payoutId) => [
    "getPayoutInvoicesPdf",
    { url: getPayoutInvoicesPdfUrl(id, payoutId) },
  ],
  getDropdownValues: (type, params) => ["dropdown", { url: `${getDropDownValues(type)}${params ? '?args=' + JSON.stringify([params]) : ''}` }],
  getReportGst: (teamId, body) => ["getReportGst", { url: reportGst(teamId), body }],
  getERPDropDownValues: () => ["getERPDropDownValues", { url: getERPDropDownValues }],
  availablePaymentGatewayListByCompany: (companyId) => [
    "availablePaymentGatewayListByCompany",
    { url: availablePaymentGatewayListByCompanyUrl(companyId) },
  ],
  thirdPartySMS: (companyId) => ["thirdPartySMS", { url: thirdPartySmsConfig(companyId) }],
  smsTemplates: (companyId, templateId) => ["smsTemplates", { url: smsTemplatesUrl(companyId, templateId) }],

  partners: () => ["partners", { url: partnersUrl }],
  partner: (id) => ["partner", { url: partnerUrl(id) }],
  savePartner: () => ["savePartner", { url: onboardUrl }],
  handshake: (partnerId) => ["handshake", { url: handshake(partnerId) }],
  handshakeAsync: (partnerId, body) => ["handshakeAsync", { url: handshakeAsyncUrl(partnerId), body, method: "POST" }],
  handshakeRetry: (partnerId, body) => ["handshakeRetry", { url: handshakeRetryUrl(partnerId), body, method: "POST" }],
  handshakeCancel: (partnerId, body) => ["handshakeCancel", { url: handshakeCancelUrl(partnerId), body, method: "POST" }],
  handshakeStatusAsync: (partnerId) => ["handshakeStatusAsync", { url: handshakeStatusAsyncUrl(partnerId) }],
  handshakeStatus: (partnerId) => ["handshakeStatus", { url: `${partnersUrl}/${partnerId}/handshake/status` }],
  getByPartyId: (id) => ["getByPartyId", { url: `${partnersUrl}/${id}/detail` }],

  // OCPI Tokens
  ocpiTokens: (params) => ["ocpiTokens", { url: ocpiTokensUrl(params), params }],
  ocpiToken: (countryCode, partyId, uid, type) => [
    "ocpiToken",
    { url: ocpiTokenUrl(countryCode, partyId, uid, type), countryCode, partyId, uid, type }
  ],
  partnerGetAllTokens: (_, params) => ["partnerGetAllTokens", { url: partnerGetAllTokensUrl(params) }],

  // Partner Commands
  sendCommand: () => ["sendCommand", { url: partnerSendCommandUrl }],
  partnerCommands: (partnerId, params) => [
    "partnerCommands",
    { url: partnerCommandsUrl(partnerId, params), partnerId, params }
  ],
  partnerCommandStatus: (commandId) => [
    "partnerCommandStatus",
    { url: partnerCommandStatusUrl(commandId), commandId }
  ],

  // Additional Partner Keys
  partnerByPartyId: (partyId) => ["partnerByPartyId", { url: partnerByPartyIdUrl(partyId), partyId }],

  // Command Builder Dropdown Keys
  commandBuilderData: () => ["commandBuilderData", { url: commandBuilderDataUrl }],
  activeCommands: (params = {}) => ["activeCommands", { url: activeCommandsUrl(params) }],
  commandsHistory: (_, params = {}) => ["commandsHistory", { url: commandsHistoryUrl(params) }],

  // Sessions API
  ongoingSessions: (_, params = {}) => ["ongoingSessions", { url: ongoingSessionsUrl(params) }],
  completedSessions: (_, params = {}) => ["completedSessions", { url: completedSessionsUrl(params) }],

  // Tariffs API
  getAllTariffs: (_, params = {}) => ["getAllTariffs", { url: partnerGetAllTariffsUrl(params) }],

  // EMSP Markup API
  emspMarkupUpsert: (_, body = {}) => ["emspMarkupUpsert", { url: emspMarkupUpsertUrl, body, method: "POST" }],

  // Analytics API
  analytics: (_, body = {}) => ["analytics", { url: analyticsUrl, body, method: "POST" }],
  analyticsTypes: () => ["analyticsTypes", { url: analyticsTypesUrl }],
  analyticsMetadata: () => ["analyticsMetadata", { url: analyticsMetadataUrl }],
  analyticsMetrics: (_, { category, params }) => ["analyticsMetrics", { url: analyticsMetricsUrl(category, params) }],
  analyticsReport: (_, body = {}) => ["analyticsReport", { url: analyticsReportUrl, body, method: "POST" }],

  // Locations API
  getAllLocations: (_, params = {}) => ["getAllLocations", { url: getAllLocationsUrl(params) }],

  // Payout Run History
  payoutRunHistory: (_, companyId, params) => ["payoutRunHistory", { url: getPayoutRunHistoryUrl(companyId, params) }],
  payoutRunDetail: (_, companyId, logId) => ["payoutRunDetail", { url: getPayoutRunDetailUrl(companyId, logId) }],

  // Payout Report tab
  payoutReportList: (teamId, params) => ["payoutReportList", { url: payoutReportList(teamId, params) }],

  // OCPI Dashboard API
  dashboardData: () => ["dashboardData", { url: dashboardDataUrl }],

  // Promo Codes
  promoCodes: (teamId) => ["promoCodes", { url: promoCodesUrl(teamId) }],
  promoCode: (teamId, promoCodeId) => ["promoCode", { url: promoCodeByIdUrl(teamId, promoCodeId) }],
  checkPromoCode: (teamId, code) => ["checkPromoCode", { url: `${checkPromoCodeUrl(teamId)}?code=${code}` }],
  updatePromoCodeStatus: (teamId, promoCodeId) => ["updatePromoCodeStatus", { url: updatePromoCodeStatusUrl(teamId, promoCodeId) }],

  promoStats: (teamId, params) => [
    "promoStats",
    {
      url: `${promoCodesUrl(teamId)}/statsData${params ? `?${Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join("&")}` : ''}`
    }
  ],
  promoGraph: (teamId, params) => [
    "promoGraph",
    {
      url: `${promoCodesUrl(teamId)}/graph${params ? `?${Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join("&")}` : ''}`
    }
  ],
  // Fleet (FLEET_MANAGEMENT)
  // Client-paginated fleet tables fetch up to FLEET_LIST_PAGE_SIZE rows in one
  // call (backend list endpoints default to 10 otherwise).
  fleetOperators: (teamId, params) => [
    "fleetOperators",
    {
      url: getTeamUrl(
        teamId,
        fleetOperatorsUrl({ page: 0, pageSize: FLEET_LIST_PAGE_SIZE, ...params })
      ),
    },
  ],
  fleetOperator: (teamId, fleetOperatorId) => [
    "fleetOperator",
    { url: getTeamUrl(teamId, fleetOperatorIdUrl(fleetOperatorId)) },
  ],
  fleetDrivers: (teamId, fleetOperatorId) => [
    "fleetDrivers",
    { url: getTeamUrl(teamId, `${fleetDriversUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetVehicles: (teamId, fleetOperatorId) => [
    "fleetVehicles",
    { url: getTeamUrl(teamId, `${fleetVehiclesUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetAssignments: (teamId, fleetOperatorId) => [
    "fleetAssignments",
    { url: getTeamUrl(teamId, `${fleetAssignmentsUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetChargerAccess: (teamId, fleetOperatorId) => [
    "fleetChargerAccess",
    { url: getTeamUrl(teamId, `${fleetChargerAccessUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetTariffs: (teamId, fleetOperatorId) => [
    "fleetTariffs",
    { url: getTeamUrl(teamId, `${fleetTariffsUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetTariff: (teamId, fleetOperatorId, tariffPlanId) => [
    "fleetTariff",
    { url: getTeamUrl(teamId, fleetTariffIdUrl(fleetOperatorId, tariffPlanId)) },
  ],
  fleetWallet: (teamId, fleetOperatorId) => [
    "fleetWallet",
    { url: getTeamUrl(teamId, fleetWalletUrl(fleetOperatorId)) },
  ],
  fleetWalletLedger: (teamId, fleetOperatorId, params) => [
    "fleetWalletLedger",
    { url: getTeamUrl(teamId, fleetWalletLedgerUrl(fleetOperatorId, params)) },
  ],
  fleetRfidMappings: (teamId, fleetOperatorId) => [
    "fleetRfidMappings",
    { url: getTeamUrl(teamId, `${fleetRfidMappingsUrl(fleetOperatorId)}${FLEET_LIST_QUERY}`) },
  ],
  fleetOperatorUsers: (teamId, fleetOperatorId) => [
    "fleetOperatorUsers",
    { url: getTeamUrl(teamId, fleetOperatorUsersUrl(fleetOperatorId)) },
  ],
  fleetSessions: (teamId, fleetOperatorId, params) => [
    "fleetSessions",
    { url: getTeamUrl(teamId, fleetSessionsUrl(fleetOperatorId, params)) },
  ],
  fleetReportSummary: (teamId, fleetOperatorId, params) => [
    "fleetReportSummary",
    { url: getTeamUrl(teamId, fleetReportSummaryUrl(fleetOperatorId, params)) },
  ],
  initiateChargerLicenseSale: () => ["initiateChargerLicenseSale", { url: initiateChargerLicenseSaleUrl }],
  profileChargerLicense: (teamId) => ["profileChargerLicense", { url: getProfileChargerLicenseUrl(teamId) }],
  teamChargerLicenseReport: (teamId) => ["teamChargerLicenseReport", { url: teamChargerLicenseReportUrl(teamId) }],
  licensesDetails: (teamId, params = {}) => {
    const { count = false } = params;
    return [
      "licensesDetails", 
      { 
        url: getLicensesDetailsUrl(teamId, count), 
        teamId, 
        count 
      }
    ];
  },
};
